import { Helmet } from "react-helmet";

interface IProps {
  children: React.ReactNode;
}

/**
 * @author traj3ctory
 * @function @AppHelmet
 **/

export default function AppHelmet({ children }: IProps) {
  return <Helmet>{children}</Helmet>;
}
